import { GAME_SERVICE_API_BASE, USE_MOCK_DATA } from "../common/api_constants";

// Diagnostic events for the lobby ↔ game handoff (which message the game sent,
// when the iframe closed, when the resume prompt appeared, page hidden, ...).
// rivalz-games-services writes each one as a single `[CLIENT-EVENT]` log line
// next to its game-finish / game-state logs, so an incident can be replayed
// from one query. Fire-and-forget: never awaited, never throws.
//
// `keepalive` lets the request outlive the page, so events sent while the tab
// or the host page's iframe is being torn down still arrive.
export const logClientEvent = (
  event,
  { sessionId, registrationId, lobbyId, gameName, ...data } = {},
) => {
  if (USE_MOCK_DATA) return;
  try {
    fetch(`${GAME_SERVICE_API_BASE}/api/client-events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        event,
        sessionId,
        registrationId,
        lobbyId,
        gameName,
        data,
      }),
    }).catch(() => {});
  } catch {
    // diagnostics must never affect gameplay
  }
};
